import React from "react"
import { usePaths } from "@engaging-tech/routing"

import { libraryPostTypes } from "../../../features/userGeneratedContent/lib/postTypes"

import DetailsLayout from "../../../layouts/DetailsLayout"
import AuthGuard from "../../../features/ui/containers/AuthGuard"
import Publish from "../../../features/businessLibrary/containers/Publish"

const PublishLectureForm = Publish(libraryPostTypes.lectures)

const Lecture = () => {
  const paths = usePaths()

  return (
    <AuthGuard>
      <DetailsLayout
        backTo={paths.resourceCentre.browse.lectures.selectedLecture}
      >
        <PublishLectureForm />
      </DetailsLayout>
    </AuthGuard>
  )
}

export default Lecture
